/* --------------------------------------------------------------------------
   HOMEPAGE FACETS - OPTIMIZED VERSION WITH MOBILE DRAWER FIX
---------------------------------------------------------------------------- */

// Debounce helper
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

/* -------------------------------------------------------------
   MOBILE DRAWER STATE MANAGEMENT
-------------------------------------------------------------- */

let mobileDrawerState = {
  openFilterId: null,
  scrollPosition: 0,
  priceInputValues: {}
};

function captureMobileDrawerState() {
  const mobileDrawer = document.querySelector('.mobile-facets__wrapper details[open]');
  mobileDrawerState.openFilterId = mobileDrawer ? mobileDrawer.id : null;
  
  const targetMobile = document.querySelector('#FacetsWrapperMobile');
  mobileDrawerState.scrollPosition = targetMobile ? targetMobile.scrollTop : 0;
  
  // Capture price input values
  const priceInputs = document.querySelectorAll('.mobile-facets__wrapper input[type="number"]');
  mobileDrawerState.priceInputValues = {};
  priceInputs.forEach((input, index) => {
    mobileDrawerState.priceInputValues[`price${index}`] = input.value;
  });
  
  console.log("💾 Captured mobile drawer state:", mobileDrawerState);
}

function restoreMobileDrawerState() {
  console.log("🔓 Restoring mobile drawer state:", mobileDrawerState);
  
  // Restore open filter
  if (mobileDrawerState.openFilterId) {
    setTimeout(() => {
      const mobileFilterToOpen = document.getElementById(mobileDrawerState.openFilterId);
      if (mobileFilterToOpen && !mobileFilterToOpen.open) {
        mobileFilterToOpen.open = true;
        console.log("✅ Restored open filter:", mobileDrawerState.openFilterId);
      }
    }, 100);
  }
  
  // Restore scroll position
  setTimeout(() => {
    const targetMobile = document.querySelector('#FacetsWrapperMobile');
    if (targetMobile && mobileDrawerState.scrollPosition > 0) {
      targetMobile.scrollTop = mobileDrawerState.scrollPosition;
    }
  }, 150);
  
  // Restore price input values
  setTimeout(() => {
    const priceInputs = document.querySelectorAll('.mobile-facets__wrapper input[type="number"]');
    priceInputs.forEach((input, index) => {
      const savedValue = mobileDrawerState.priceInputValues[`price${index}`];
      if (savedValue !== undefined && savedValue !== '') {
        input.value = savedValue;
      }
    });
  }, 200);
}

/* -------------------------------------------------------------
   FILTER INJECTION SYSTEM WITH MOBILE DRAWER PRESERVATION
-------------------------------------------------------------- */

function injectHomepageFilters() {
  console.log("🔄 Homepage: Injecting filters...");
  
  // CAPTURE STATE BEFORE INJECTION
  captureMobileDrawerState();

  // CAPTURE CURRENT SORT VALUE BEFORE INJECTION
  const currentSortSelect = document.querySelector('#SortBy');
  const currentSortValue = currentSortSelect ? currentSortSelect.value : '';

  const grid = document.getElementById('ProductGridContainer');
  if (!grid) {
    console.warn("❌ Grid container missing");
    return;
  }

  const collectionHandle = grid.dataset.collectionHandle || 'shop-all';
  const sectionId = grid.dataset.sectionId;
  
  if (!collectionHandle) {
    console.warn("❌ Missing collection handle");
    return;
  }

  // Include current filter params to maintain state
  const currentParams = window.location.search || "";
  const url = `/collections/${collectionHandle}${currentParams}${currentParams ? '&' : '?'}section_id=${sectionId}`;
  
  console.log("📡 Filter Load URL with params:", url);

  fetch(url)
    .then(response => {
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.text();
    })
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      console.log("✅ Filtered collection page HTML received");

      // Update desktop filters
      const filtersDesktop = doc.querySelector('#FacetsWrapperDesktop');
      const targetDesktop = document.querySelector('#FacetsWrapperDesktop');
      if (filtersDesktop && targetDesktop) {
        targetDesktop.innerHTML = filtersDesktop.innerHTML;
        console.log("✅ Desktop filters injected with current state");
      }

      // Update mobile filters - WITH STATE PRESERVATION
      const filtersMobile = doc.querySelector('#FacetsWrapperMobile');
      const targetMobile = document.querySelector('#FacetsWrapperMobile');
      if (filtersMobile && targetMobile) {
        targetMobile.innerHTML = filtersMobile.innerHTML;
        console.log("✅ Mobile filters injected");
      }

      // RESTORE THE SORT SELECTION AFTER INJECTION
      if (currentSortValue) {
        setTimeout(() => {
          const newSortSelect = document.querySelector('#SortBy');
          if (newSortSelect && newSortSelect.value !== currentSortValue) {
            newSortSelect.value = currentSortValue;
            console.log("🔄 Restored sort selection to:", currentSortValue);
          }
          
          const mobileSortSelect = document.querySelector('#SortBy-mobile');
          if (mobileSortSelect && mobileSortSelect.value !== currentSortValue) {
            mobileSortSelect.value = currentSortValue;
          }
        }, 50);
      }

      // Re-initialize event listeners after injection
      initializeFacetEvents();
      
      // SYNC FILTERS WITH CURRENT URL STATE
      setTimeout(() => {
        syncFiltersWithURL();
      }, 400);
      
      // RESTORE MOBILE DRAWER STATE after everything is loaded
      setTimeout(() => {
        restoreMobileDrawerState();
      }, 500);
      
      // RE-INITIALIZE WIDTH ADJUSTMENTS for new select elements
      setTimeout(() => {
        const newSelectElement = document.querySelector('#SortBy');
        if (newSelectElement) {
          initializeSelectWidth(newSelectElement);
        }
      }, 100);
      
      console.log("🎉 Filters injected successfully with maintained state");

    })
    .catch(err => {
      console.error("❌ Failed loading filters:", err);
    });
}

/* -------------------------------------------------------------
   ENHANCED MOBILE CHECKBOX & PRICE INPUT HANDLING
-------------------------------------------------------------- */

function initializeMobileCheckboxHandling() {
  console.log("📱 Initializing mobile checkbox handling...");
  
  const mobileCheckboxes = document.querySelectorAll('.mobile-facets__wrapper input[type="checkbox"]');
  
  mobileCheckboxes.forEach(checkbox => {
    // Remove any existing event listeners by cloning
    const newCheckbox = checkbox.cloneNode(true);
    checkbox.parentNode.replaceChild(newCheckbox, checkbox);
    
    newCheckbox.addEventListener('change', function(event) {
      console.log("🎯 Mobile checkbox changed");

      // Prevent drawer closing only
      event.stopPropagation();

      captureMobileDrawerState();

      setTimeout(() => {
        const form = this.closest('facet-filters-form');
        if (form && form.debouncedOnSubmit) {
          form.debouncedOnSubmit(event);
        }
      }, 100);
    });
  });
}

function initializeMobilePriceRangeHandling() {
  console.log("💰 Initializing mobile price range handling...");
  
  const mobilePriceInputs = document.querySelectorAll('.mobile-facets__wrapper input[type="number"]');
  
  mobilePriceInputs.forEach(input => {
    const newInput = input.cloneNode(true);
    input.parentNode.replaceChild(newInput, input);
    
    let debounceTimer;
    
    newInput.addEventListener('input', function(event) {
      console.log("💰 Mobile price input typing");
      
      // Clear any existing timer
      clearTimeout(debounceTimer);
      
      // Capture state continuously while typing
      captureMobileDrawerState();
      
      // Set new timer - wait 1 second after typing stops
      debounceTimer = setTimeout(() => {
        console.log("💰 Mobile price input - applying after debounce");
        const form = this.closest('facet-filters-form');
        if (form && form.debouncedOnSubmit) {
          form.debouncedOnSubmit(event);
        }
      }, 1000);
    });
    
    newInput.addEventListener('blur', function(event) {
      console.log("💰 Mobile price input - immediate update on blur");
      // Clear debounce timer and update immediately
      clearTimeout(debounceTimer);
      
      // Capture final state
      captureMobileDrawerState();
      
      const form = this.closest('facet-filters-form');
      if (form && form.debouncedOnSubmit) {
        form.debouncedOnSubmit(event);
      }
    });
  });
}

/* -------------------------------------------------------------
   ENHANCED PRICE RANGE CLASS WITH DEBOUNCED UPDATES
-------------------------------------------------------------- */

class PriceRange extends HTMLElement {
  constructor() {
    super();
    console.log("💰 PriceRange constructor - initializing with debounced updates");
    
    this.inputs = this.querySelectorAll('input');
    this.debouncedOnRangeChange = debounce((event) => {
      this.onRangeChangeFinal(event);
    }, 800);
    
    this.inputs.forEach((element) => {
      const newInput = element.cloneNode(true);
      element.parentNode.replaceChild(newInput, element);
      
      newInput.addEventListener('input', this.debouncedOnRangeChange.bind(this));
      newInput.addEventListener('change', this.onRangeChange.bind(this));
      newInput.addEventListener('blur', this.onBlur.bind(this));
    });
    
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    console.log("💰 Price range immediate change");
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onRangeChangeFinal(event) {
    console.log("💰 Price range debounced change - applying filters");
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    
    // Capture state before filter update
    captureMobileDrawerState();
    
    const form = this.closest('facet-filters-form');
    if (form && form.debouncedOnSubmit) {
      form.debouncedOnSubmit(event);
    }
  }

  onBlur(event) {
    console.log("💰 Price range input blur - immediate update");
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    
    // Capture state before filter update
    captureMobileDrawerState();
    
    const form = this.closest('facet-filters-form');
    if (form && form.debouncedOnSubmit) {
      form.debouncedOnSubmit(event);
    }
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('max') || 10000);
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min')) || 0;
    const max = Number(input.getAttribute('data-max')) || 10000;

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

// Replace existing PriceRange class
if (customElements.get('price-range')) {
  customElements.get('price-range').class = PriceRange;
} else {
  customElements.define('price-range', PriceRange);
}

/* -------------------------------------------------------------
   URL SYNCHRONIZATION - SYNC FILTERS WITH URL STATE
-------------------------------------------------------------- */

function syncFiltersWithURL() {
  console.log("🔄 Syncing filters with current URL state");
  
  const urlParams = new URLSearchParams(window.location.search);
  
  // Helper function to get all values for a parameter
  function getAllParamValues(paramName) {
    return Array.from(urlParams.getAll(paramName));
  }
  
  // Sync desktop checkboxes
  const desktopCheckboxes = document.querySelectorAll('#FacetsWrapperDesktop input[type="checkbox"]');
  desktopCheckboxes.forEach(checkbox => {
    const paramName = checkbox.name;
    const paramValue = checkbox.value;
    const activeValues = getAllParamValues(paramName);
    const isChecked = activeValues.includes(paramValue);
    checkbox.checked = isChecked;
    
    // Update the parent label class for visual state
    const label = checkbox.closest('label');
    if (label) {
      if (isChecked) {
        label.classList.add('active');
      } else {
        label.classList.remove('active');
      }
    }
  });
  
  // Sync mobile checkboxes
  const mobileCheckboxes = document.querySelectorAll('#FacetsWrapperMobile input[type="checkbox"]');
  mobileCheckboxes.forEach(checkbox => {
    const paramName = checkbox.name;
    const paramValue = checkbox.value;
    const activeValues = getAllParamValues(paramName);
    const isChecked = activeValues.includes(paramValue);
    checkbox.checked = isChecked;
    
    // Update mobile visual state
    const label = checkbox.closest('label');
    if (label) {
      if (isChecked) {
        label.classList.add('active');
      } else {
        label.classList.remove('active');
      }
    }
  });
  
  // Sync price inputs
  const minPriceInput = document.querySelector('input[name="filter.v.price.gte"]');
  const maxPriceInput = document.querySelector('input[name="filter.v.price.lte"]');
  
  if (minPriceInput) {
    minPriceInput.value = urlParams.get('filter.v.price.gte') || '';
  }
  if (maxPriceInput) {
    maxPriceInput.value = urlParams.get('filter.v.price.lte') || '';
  }
  
  console.log("✅ Filters synced with URL");
}

/* -------------------------------------------------------------
   ENHANCED FACET EVENTS
-------------------------------------------------------------- */

function initializeFacetEvents() {
  console.log("🔌 Initializing facet events with enhanced mobile handling...");
  
  // Re-initialize event listeners for all facet forms
  const facetForms = document.querySelectorAll('facet-filters-form');
  
  facetForms.forEach(form => {
    const forms = form.querySelectorAll('form');
    forms.forEach(f => {
      const newForm = f.cloneNode(true);
      f.parentNode.replaceChild(newForm, f);
    });

    const newForms = form.querySelectorAll('form');
    newForms.forEach(f => {
      if (form.debouncedOnSubmit) {
        f.removeEventListener('input', form.debouncedOnSubmit.bind(form));
        f.removeEventListener('change', form.debouncedOnSubmit.bind(form));
        
        f.addEventListener('input', form.debouncedOnSubmit.bind(form));
        f.addEventListener('change', form.debouncedOnSubmit.bind(form));
      }
    });
  });

  // Enhanced mobile handlers
  initializeMobileCheckboxHandling();
  initializeMobilePriceRangeHandling();

  // SYNC FILTERS WITH CURRENT URL STATE
  setTimeout(() => {
    syncFiltersWithURL();
  }, 300);
}

/* -------------------------------------------------------------
   SORT BY: FIX TO PRESERVE EXISTING FILTERS WITH CORRECT URL FORMAT
-------------------------------------------------------------- */

document.addEventListener("DOMContentLoaded", () => {
  // Handle desktop sort
  const sortSelect = document.getElementById("SortBy");
  if (sortSelect) {
    sortSelect.addEventListener("change", function(event) {
      handleSortChange(this.value, event);
    });
  }
  
  // Handle mobile sort
  const mobileSortSelect = document.getElementById("SortBy-mobile");
  if (mobileSortSelect) {
    mobileSortSelect.addEventListener("change", function(event) {
      handleSortChange(this.value, event);
    });
  }

  function handleSortChange(selectedSort, event) {
    console.log("🔄 Sort changed to:", selectedSort);
    
    // Get ALL current URL parameters (including all active filters)
    const currentParams = new URLSearchParams(FacetFiltersForm.searchParamsPrev || window.location.search);
    
    // Update or remove sort parameter while preserving all other params
    if (selectedSort && selectedSort !== "") {
      currentParams.set("sort_by", selectedSort);
    } else {
      currentParams.delete("sort_by");
    }
    
    console.log("✅ Updated URL with filters preserved:", currentParams.toString());
    
    // Render with AJAX - this will preserve all existing filters
    FacetFiltersForm.renderPage(currentParams.toString(), event);
  }
});

/* -------------------------------------------------------------
   FACET FILTER SYSTEM - MAIN LOGIC
-------------------------------------------------------------- */

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    console.log("🏠 FacetFiltersForm constructor");
    
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const forms = this.querySelectorAll('form');
    forms.forEach(form => {
      form.addEventListener('input', this.debouncedOnSubmit.bind(this));
      form.addEventListener('change', this.debouncedOnSubmit.bind(this));
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    console.log('🔄 FacetFiltersForm: Rendering page with params:', searchParams);
    
    // CAPTURE MOBILE STATE BEFORE RENDERING
    captureMobileDrawerState();
    
    // CAPTURE CURRENT SORT VALUE BEFORE RENDERING
    const currentSortSelect = document.querySelector('#SortBy');
    const currentSortValue = currentSortSelect ? currentSortSelect.value : '';
    
    const sections = FacetFiltersForm.getSections();
    if (sections.length === 0) {
      console.error('❌ No sections found for filtering');
      return;
    }

    // Show loading states
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      const collectionElement = productGridContainer.querySelector('.collection');
      if (collectionElement) {
        collectionElement.classList.add('loading');
      }
    }

    const loadingOverlays = document.querySelectorAll('.loading-overlay');
    loadingOverlays.forEach(overlay => {
      overlay.style.display = 'block';
    });

    sections.forEach((section) => {
      const collectionHandle = productGridContainer?.dataset.collectionHandle || 'shop-all';
      const url = `/collections/${collectionHandle}?${searchParams}`;
      
      FacetFiltersForm.renderSectionFromFetch(url, event, currentSortValue);
    });

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(searchParams);
    }
  }

  static renderSectionFromFetch(url, event, currentSortValue = '') {
    console.log('🔄 Fetching ACTUAL filtered collection from:', url);
    
    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.text();
      })
      .then((responseText) => {
        console.log('✅ Received ACTUAL filtered collection HTML');
        
        const parser = new DOMParser();
        const doc = parser.parseFromString(responseText, 'text/html');
        
        const productItems = doc.querySelectorAll('.collection-grid__item');
        console.log(`📦 Found ${productItems.length} filtered products in collection page`);
        
        if (productItems.length > 0) {
          FacetFiltersForm.updateProductGridWithFilteredProducts(doc);
        } else {
          FacetFiltersForm.renderProductGridContainer(responseText);
        }
        
        FacetFiltersForm.renderProductCount(responseText);

        // Update homepage active filters
        updateActiveFilters(doc);
        
        // RESTORE SORT SELECTION AFTER FILTERING
        if (currentSortValue) {
          setTimeout(() => {
            const sortSelect = document.querySelector('#SortBy');
            if (sortSelect && sortSelect.value !== currentSortValue) {
              sortSelect.value = currentSortValue;
            }
            
            const mobileSortSelect = document.querySelector('#SortBy-mobile');
            if (mobileSortSelect && mobileSortSelect.value !== currentSortValue) {
              mobileSortSelect.value = currentSortValue;
            }
          }, 100);
        }
        
        // SYNC FILTERS WITH CURRENT URL STATE
        setTimeout(() => {
          syncFiltersWithURL();
        }, 200);
        
        // Hide loading states
        const loadingOverlays = document.querySelectorAll('.loading-overlay');
        loadingOverlays.forEach(overlay => {
          overlay.style.display = 'none';
        });
        
        const productGridContainer = document.getElementById('ProductGridContainer');
        if (productGridContainer) {
          const collectionElement = productGridContainer.querySelector('.collection');
          if (collectionElement) {
            collectionElement.classList.remove('loading');
          }
        }
        
        console.log('✅ Filtered product grid updated successfully');
      })
      .catch(error => {
        console.error('❌ Error fetching filtered results:', error);
        const loadingOverlays = document.querySelectorAll('.loading-overlay');
        loadingOverlays.forEach(overlay => {
          overlay.style.display = 'none';
        });
      });
  }

  static updateProductGridWithFilteredProducts(doc) {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;

    const filteredProductGrid = doc.querySelector('#product-grid');
    
    if (filteredProductGrid) {
      productGrid.innerHTML = filteredProductGrid.innerHTML;
      
      const newProductItems = productGrid.querySelectorAll('.collection-grid__item');
      
      const productCountDisplay = document.getElementById('ProductCountDisplay');
      if (productCountDisplay) {
        productCountDisplay.textContent = `Showing ${newProductItems.length} filtered products`;
      }
    }
  }

  static renderProductGridContainer(html) {
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const newProductGridContainer = parsedHTML.getElementById('ProductGridContainer');
      
      if (newProductGridContainer) {
        productGridContainer.innerHTML = newProductGridContainer.innerHTML;
      }
    }
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    
    const productCount = parsedHTML.getElementById('ProductCount');
    const targetProductCount = document.getElementById('ProductCount');
    if (productCount && targetProductCount) {
      targetProductCount.innerHTML = productCount.innerHTML;
    }
    
    const productCountDesktop = parsedHTML.getElementById('ProductCountDesktop');
    const targetProductCountDesktop = document.getElementById('ProductCountDesktop');
    if (productCountDesktop && targetProductCountDesktop) {
      targetProductCountDesktop.innerHTML = productCountDesktop.innerHTML;
    }
  }

  static updateURLHash(searchParams) {
    const newUrl = `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`;
    history.pushState({ searchParams }, '', newUrl);
  }

  static getSections() {
    const productGridContainer = document.getElementById('ProductGridContainer');
    
    if (productGridContainer) {
      if (productGridContainer.dataset.sectionId) {
        return [{ 
          id: productGridContainer.dataset.sectionId,
          section: productGridContainer.dataset.sectionId 
        }];
      }
      
      const productGrid = document.getElementById('product-grid');
      if (productGrid && productGrid.dataset.id) {
        return [{ 
          id: productGrid.dataset.id,
          section: productGrid.dataset.id 
        }];
      }
    }
    
    return [{ 
      id: 'shop-all-product-grid',
      section: 'shop-all-product-grid' 
    }];
  }

  createSearchParams(form) {
    // Start with ALL current URL parameters to preserve existing state
    const urlParams = new URLSearchParams(FacetFiltersForm.searchParamsPrev || window.location.search);
    
    if (form) {
      const formData = new FormData(form);
      
      // Clear existing filter parameters that might be updated by this form
      // But preserve other parameters like sort_by
      const filterKeysToClear = [];
      for (let [key] of formData.entries()) {
        if (key.startsWith('filter.')) {
          filterKeysToClear.push(key);
        }
      }
      
      // Remove only the filter parameters that are being updated
      filterKeysToClear.forEach(key => {
        urlParams.delete(key);
      });
      
      // Add current form values - handle multiple values properly
      for (let [key, value] of formData.entries()) {
        // Skip empty values (like empty price inputs)
        if (value !== "" && value !== null && value !== undefined) {
          // For filter parameters, use append to allow multiple values
          if (key.startsWith('filter.')) {
            urlParams.append(key, value);
          } else {
            // For other parameters (like sort_by), use set to replace
            urlParams.set(key, value);
          }
        }
      }
      
      // Special handling for checkboxes - ensure unchecked values are removed
      const checkboxes = form.querySelectorAll('input[type="checkbox"]');
      const checkedValues = {};
      
      // First, collect all checked values by parameter name
      checkboxes.forEach(checkbox => {
        if (checkbox.checked) {
          const paramName = checkbox.name;
          const paramValue = checkbox.value;
          if (!checkedValues[paramName]) {
            checkedValues[paramName] = [];
          }
          checkedValues[paramName].push(paramValue);
        }
      });
      
      // Now update URL params to match the checked state
      Object.keys(checkedValues).forEach(paramName => {
        // Remove all existing values for this parameter
        urlParams.delete(paramName);
        
        // Add back only the checked values
        checkedValues[paramName].forEach(value => {
          urlParams.append(paramName, value);
        });
      });
      
      // Clean up empty price parameters
      if (urlParams.get('filter.v.price.gte') === '') {
        urlParams.delete('filter.v.price.gte');
      }
      if (urlParams.get('filter.v.price.lte') === '') {
        urlParams.delete('filter.v.price.lte');
      }
    }
    
    return urlParams.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    let form;
    if (event.target.closest('form')) {
      form = event.target.closest('form');
    } else {
      form = this.querySelector('#FacetFiltersForm') || this.querySelector('#FacetSortDrawerForm');
    }
    
    if (form) {
      const searchParams = this.createSearchParams(form);
      this.onSubmitForm(searchParams, event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

// Initialize system
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);

if (!customElements.get('facet-filters-form')) {
  customElements.define('facet-filters-form', FacetFiltersForm);
}

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const link = this.querySelector('a');
    if (link) link.addEventListener('click', this.closeFilter.bind(this));
  }
  closeFilter(event) {
    event.preventDefault();
    const form = document.querySelector('facet-filters-form');
    if (form) form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/* -------------------------------------------------------------
   SELECT WIDTH ADJUSTMENT FUNCTIONS
-------------------------------------------------------------- */

function initializeSelectWidth(selectElement) {
  if (!selectElement) return;
  
  adjustSelectWidthToSelected(selectElement);
  
  selectElement.addEventListener('focus', function() {
    adjustSelectWidthOnFocus(selectElement);
  });
  
  selectElement.addEventListener('blur', function() {
    adjustSelectWidthToSelected(selectElement);
  });
  
  selectElement.addEventListener('change', function() {
    setTimeout(() => {
      adjustSelectWidthToSelected(selectElement);
    }, 50);
  });
}

function adjustSelectWidthToSelected(selectElement) {
  const selectedOptionText = selectElement.options[selectElement.selectedIndex].text.trim();
  
  const tempSpan = document.createElement('span');
  tempSpan.style.position = 'absolute';
  tempSpan.style.opacity = '0';
  tempSpan.style.whiteSpace = 'nowrap';

  let isMobile = window.innerWidth <= 768; 
  tempSpan.style.font = isMobile ? '12px trios' : '16px trios';
  
  document.body.appendChild(tempSpan);
  tempSpan.textContent = selectedOptionText;
  let textWidth = tempSpan.offsetWidth;
  
  document.body.removeChild(tempSpan);
  
  const padding = isMobile ? 25 : 30;
  selectElement.style.width = (textWidth + padding) + 'px';
}

function adjustSelectWidthOnFocus(selectElement) {
  const options = selectElement.options;
  let maxWidth = 0;
  
  const tempSpan = document.createElement('span');
  tempSpan.style.position = 'absolute';
  tempSpan.style.opacity = '0';
  tempSpan.style.whiteSpace = 'nowrap';
  tempSpan.style.font = '16px trios';
  
  document.body.appendChild(tempSpan);
  
  for (let i = 0; i < options.length; i++) {
    tempSpan.textContent = options[i].text.trim();
    let textWidth = tempSpan.offsetWidth;
    if (textWidth > maxWidth) {
      maxWidth = textWidth;
    }
  }
  
  document.body.removeChild(tempSpan);
  
  let expandedWidth = maxWidth + 50;
  let isMobile = window.innerWidth <= 768;
  
  if (isMobile) {
    expandedWidth = Math.max(expandedWidth, 170);
  } else {
    expandedWidth = Math.max(expandedWidth, 200);
  }
  
  selectElement.style.width = expandedWidth + 'px';
}

/* -------------------------------------------------------------
   GLOBAL EVENT PROTECTION
-------------------------------------------------------------- */

document.addEventListener('click', function(event) {
  // Prevent clicks inside mobile filters from closing the drawer
  if (event.target.closest('.mobile-facets__submenu') || 
      event.target.closest('.mobile-facets__list') ||
      event.target.closest('.mobile-facets__item')) {
    event.stopPropagation();
  }
}, true);

/* -------------------------------------------------------------
   INITIALIZATION
-------------------------------------------------------------- */

document.addEventListener('DOMContentLoaded', function() {
  console.log("🚀 Initializing homepage filters with mobile state preservation...");
  
  const urlParams = new URLSearchParams(window.location.search);
  const sortByFromURL = urlParams.get('sort_by');
  
  setTimeout(() => {
    const sortSelect = document.querySelector('#SortBy');
    if (sortSelect) {
      if (sortByFromURL) {
        sortSelect.value = sortByFromURL;
      } else {
        sortSelect.value = "";
      }
    }
    
    const mobileSortSelect = document.querySelector('#SortBy-mobile');
    if (mobileSortSelect) {
      if (sortByFromURL) {
        mobileSortSelect.value = sortByFromURL;
      } else {
        mobileSortSelect.value = "";
      }
    }
  }, 100);
  
  setTimeout(() => {
    const selectElement = document.querySelector('#SortBy');
    if (selectElement) {
      initializeSelectWidth(selectElement);
    }
  }, 200);
  
  injectHomepageFilters();
  FacetFiltersForm.setListeners();
  
  if (urlParams.toString()) {
    setTimeout(() => {
      FacetFiltersForm.renderPage(urlParams.toString(), null, false);
    }, 200);
  }
});

function updateActiveFilters(doc) {
  const activeFiltersContainer = document.querySelector('#ActiveFiltersHomepage');
  if (!activeFiltersContainer) return;

  const newActiveFilters = doc.querySelector('.active-facets');
  
  if (newActiveFilters) {
    activeFiltersContainer.innerHTML = newActiveFilters.innerHTML;
  } else {
    activeFiltersContainer.innerHTML = "";
  }
}